import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Form from '../../../components/form/Form';
import { addNewOffice, fetchAllOffices, resetStatus } from '../../../redux/slice/office/officeSlice';
import { flashMessage as flash } from '../../../utils/flash';
import { isEmptyObject } from '../../../utils/validators/validators';
import PageTitle from './../../../components/partials/PageTitle';
import useInputChange from './../../../utils/hooks/useInputChange';

const AddOffice = () => {
    const initialOfficeData = {
        office_name: '',
        location: '',
        office_address: '',
        parent_id: '',
        office_code: '',
    }
    const [officeInputData, setOfficeInputData] = useState(initialOfficeData)
    const [error, setError] = useState({})
    const { user } = useSelector((state) => state.auth?.user);
    const { user_permissions } = useSelector((state) => state.auth?.user);
    const { offices, isLoading, isSuccess, isError, message } = useSelector(
      (state) => state.office
    );

    const [input, handleChange] = useInputChange(
      officeInputData,
      setOfficeInputData,
      error,
      setError
    );

    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Create Office Controller
    const handleSubmit = () => {
      if (isEmptyObject(error)) {
        dispatch(addNewOffice(officeInputData));
      }
    };
    useEffect(() => {
      // if (isError) {
      //   flash("error", message);
      //   dispatch(resetStatus());
      // }
      if (isSuccess) {
        // Reset Input Fields
        setOfficeInputData(() => {
          return initialOfficeData;
        });
      }
      return () => {
        dispatch(resetStatus());
      };
    }, [offices, isSuccess,]);

    useEffect(() => {
      if (offices.length === 0) {
        dispatch(fetchAllOffices({ office_id: user?.office_id }));
        dispatch(resetStatus());
      }
    }, []);

    useEffect(() => {
      if (!user_permissions?.some(permission => permission.name === 'office module') || !user_permissions?.some(permission => permission.name === 'create office')) {
        navigate('/admin/dashboard')
      }
    }, [navigate, user_permissions])

    const breadcrumb = {
      from: {
        title: "Office",
        link: "/admin/office-list",
      },
      current: {
        title: "add office",
        link: null,
      },
    };

    if (offices?.length === 0) {
      return <h4>Loading...</h4>;
    }

  return (
    <>
        {/* page title */}
            <PageTitle title='Add New Office' breadcrumb={breadcrumb} />
        {/* end page title */}

        {/* content */}
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row pb-2 mb-3 text-capitalize border-bottom">
                                <div className="col-md-12 d-flex justify-content-between align-items-center">
                                        <h4 className='header-title text-capitalize mb-0'>Please fill all fields</h4>
                                        <span onClick={() => navigate(-1)} className='btn btn-primary btn-sm float-end '>Go Back</span>
                                </div>
                            </div>
                            <Form method='POST' setError={setError} submitHandler={handleSubmit} values={officeInputData}>
                            <div className="row g-2">
                                <div className="mb-0 col-md-6">
                                    <label htmlFor="inputEmail4" className="form-label">Office Name <span className='text-danger'>*</span></label>
                                    <input
                                        textname='office name'
                                        min_length='2'
                                        name='office_name'
                                        onChange={handleChange}
                                        value={input.office_name}
                                        type="text" 
                                        className={`form-control ${error.office_name && 'is-invalid'}`} id="inputEmail4" placeholder="Office Name"/>
                                        {error.office_name &&  <span className='invalid-feedback'>{error.office_name}</span>}
                                </div>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="inputState" className="form-label">Select Parent Office <span className='text-danger'>*</span></label>
                                    <select 
                                        textname='parent office'
                                        name='parent_id'
                                        onChange={handleChange}
                                        id="inputState" 
                                        className={`form-select ${error.parent_id && 'is-invalid'}`}>
                                        <option value=''> Choose Office</option>
                                        {
                                            offices.offices.map(({office_name, id}) => (
                                                <option
                                                    key={office_name} 
                                                    value={id}>{office_name}</option>
                                            ))
                                        }
                                    </select>
                                    {error.parent_id &&  <span className='invalid-feedback'>{error.parent_id}</span>}
                                </div>
                            </div>
                                        
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-md-6">
                                  <label htmlFor="location" className="form-label">Location <span className='text-danger'>*</span></label>
                                  <input
                                      textname='location'
                                      min_length='3'
                                      name='location'
                                      onChange={handleChange}
                                      value={input.location}
                                      type="text" 
                                      className={`form-control ${error.location && 'is-invalid'}`} 
                                      id="inputAddress" placeholder="Benin City"/>
                                      {error.location &&  <span className='invalid-feedback'>{error.location}</span>}
                                </div>
                                <div className="col-md-6">
                                  <label  className="form-label">Office Short Code <span className='text-danger'>*</span></label>
                                  <input
                                      // textname='location'
                                      // min_length='3'
                                      name='office_code'
                                      onChange={handleChange}
                                      value={input.office_code}
                                      type="text" 
                                      className={`form-control ${error.office_code && 'is-invalid'}`} 
                                      id="inputAddress" />
                                      {error.office_code &&  <span className='invalid-feedback'>{error.office_code}</span>}
                                </div>
                              </div>
                            </div>
                            
                            <div className="mb-3">
                                <label htmlFor="example-textarea" className="form-label">Address <span className='text-danger'>*</span></label>
                                <textarea
                                    textname='office address'
                                    min_length='5'
                                    name='office_address'
                                    onChange={handleChange}
                                    value={input.office_address}
                                    className={`form-control ${error.office_address && 'is-invalid'}`} 
                                    id="example-textarea" rows="5"></textarea>
                                    {error.office_address &&  <span className='invalid-feedback'>{error.office_address}</span>}
                            </div>
                                        
                            <div className="flex-end">
                                <button disabled={isLoading && true} className="btn btn-primary w-10">Submit</button>
                            </div>
                        </Form>
                        </div>
                    </div>
                </div>
            </div>
        {/* end content */}
    </>
  )
}

export default AddOffice